import { HeadContactBook, Class } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    configs: []
  },
  actions: {
    async fetchData(_, params) {
      const res = await HeadContactBook.fetchContactBookConfig({ ...params })
      return res || []
    },
    async createData(_, params) {
      const res = await HeadContactBook.updateContactBookConfig({ ...params })
      return res
    },
    async fetchOneClass(_, id) {
      const res = await Class.fetchOne(id)
      return res || {}
    },
    async fetchConfigByDate({ commit }, params) {
      const res = await HeadContactBook.fetch({ ...params })
      commit('setConfigByDate', res || [])
      return res || []
    }
  },
  mutations: {
    setConfigByDate(state, configs = []) {
      state.config = [...configs]
    }
  },
  getters: {
    getIsConfigsExisted(state) {
      return state.configs.length > 0
    }
  }
}